"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeGroups = void 0;
var PracticeGroups_1 = require("./PracticeGroups");
Object.defineProperty(exports, "PracticeGroups", { enumerable: true, get: function () { return PracticeGroups_1.PracticeGroups; } });
//# sourceMappingURL=index.js.map